// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3s5-3","choiceBoxes":"toolbarselects_choiceBoxes__1Kwnf","simpleField":"toolbarselects_simpleField__27O9N"};